// extracted by mini-css-extract-plugin
export default {"demo":"DemoPage_demo__oTO1S"};